import { useNavigate, useOutletContext } from "react-router-dom";
import ThemeConstants from "../../../../config/theme/theme_constants";
import CurrentPoints from "../components/current_points";
import { UserInterface } from "../../../../core/components/user/domain/interfaces/user_interface";
import RewardsBackground from "../components/rewards_background";
import ExclusiveRewardsList from "../components/exclusive_rewards_list";
import { useCallback, useEffect, useRef, useState } from "react";
import FiltersDialog from "../components/filters_dialog";
import FilterIcon from '../../../../assets/images/filter_icon.svg?react';
import BackArrowIcon from '../../../../assets/images/back_arrow_icon.svg?react';
import { Trans } from 'react-i18next';
import { useTranslation } from '../../../../i18n/useTranslation';

const ExceptionalRewardsPage: React.FC = () => {
  const { t } = useTranslation();
  const theme = ThemeConstants();
  const navigate = useNavigate();
  const [ dialogOpened, setDialogOpened ] = useState(false);
  const [ filters, setFilters ] = useState<string[]>([]);
  const { experience , company } = useOutletContext<UserInterface>();

    const buttonRef = useRef<HTMLButtonElement>(null);

    const handleOpenDialog = useCallback(() => {
        if (buttonRef.current) {
            buttonRef.current.blur();
        }
        setDialogOpened(true);
    }, [setDialogOpened, buttonRef]);

  useEffect(() => {
      const prev = document.body.style.backgroundColor;
      document.body.style.backgroundColor = '#FFFFFF';
      return () => { document.body.style.backgroundColor = prev; };
  }, []);

  return (
    <div
      className="min-h-dvh w-full flex flex-col relative"
      style={{ 
        background: `linear-gradient(180deg, ${theme.UvibesOrange} 0%, ${theme.UvibesYellow} 16%)` 
      }}
    >
      <header className="flex flex-col items-center gap-8 pt-[6.5dvh] pb-[5.8dvh] relative overflow-y-clip">
        <RewardsBackground/>
        <div className="flex flex-col items-center gap-1.25 text-white relative">
          <h1 className="font-bold text-[40px] text-center leading-none"><Trans i18nKey="rewards.exceptional_title" /></h1>
          <p className="font-medium text-sm text-center">{t('rewards.exceptional_subtitle')}</p>
        </div>
      </header>
      <BackArrowIcon className="absolute top-8 start-5 cursor-pointer" width={24} height={24} onClick={() => navigate(-1)}/>
      <div className="bg-white flex-1 rounded-t-[30px] px-3 py-7 flex flex-col items-center gap-8">
        {company && company.picture && company.permissions.whiteLabel === true && <img src={company.picture} alt={t('common.logo_alt', { name: company.name })} className={`h-18 w-auto rounded-xl`}/>}
        <div className="w-full max-w-143.5 flex justify-center items-center gap-2">
            <CurrentPoints experience={experience.totalExp} className="w-1/3"/>
            <button
                className="px-9 py-4 flex w-1/3 gap-1.25 rounded-[18px] justify-center items-center cursor-pointer"
                style={{ background: theme.UvibesPink }}
                onClick={handleOpenDialog}
            >
                <FilterIcon className="h-6 w-6"/>
                <span className="text-sm font-semibold text-white text-center">{t('rewards.filter')}</span>
            </button>
        </div>
        <ExclusiveRewardsList filters={filters}/>
      </div>
      <FiltersDialog open={dialogOpened} onClose={() => setDialogOpened(false)} onValidate={(newFilters) => { setFilters(newFilters); setDialogOpened(false); }}/>
    </div>
  );
};

export default ExceptionalRewardsPage;